import React, { useEffect, useState } from 'react';
import './App.css';
import Map from './components/map/MapView';
import LoadingContext from './context/loadingContext';
import { Loading } from './components/loading/Loading';
import { useSearchParams } from "react-router-dom";
import { ConfigService } from './services/config/config';
import ParameterContext from './context/parameterContext';

interface parameterRequest {
    error: boolean,
    errorMessage: string,
    parameters?: any
}

const App: React.FC = () => {
    const [load, setLoad] = useState< number>(0);
    const [parameters, setParameter] = useState< any>(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const [deviceType, setDeviceType] = useState("desktop");
	const [errorMessage, setErrorMessage] = useState<string>("3001");

    const setLoading = (loading: boolean) => {
        if (loading) {
            setLoad(prevState => prevState + 1);
        }
        else {
            setLoad(prevState => (prevState - 1 < 0) ? 0 : prevState - 1);
        }
    }

    const config = async () => {
        const key = searchParams.get("key");
        
        const configService = new ConfigService();
        setLoading(true);
        const response: parameterRequest = await configService.getAllParameters(key);
        setLoading(false);
        if (!response.error && response.parameters){
            const parameters = checkURLParameters(response.parameters, key);
            setParameter(parameters);
			setErrorMessage("");
        }else{
           setParameter(false);
		   setErrorMessage(response.errorMessage);
        }
        
    }
    
    const checkURLParameters = (parameters: any, key: any) => {
        const opacityValue = searchParams.get("opacityValue");
        if (opacityValue !== null ){
            parameters.opacityValue= opacityValue;
        }
        const lat = searchParams.get("lat");
        if (lat !== null ){
            parameters.lat= lat;
        }
        const lng = searchParams.get("lng");
        if (lng !== null){
            parameters.lng= lng;
        }
        const z = searchParams.get("z");
        if (z!== null){
            parameters.z= z;
        }
        const w = searchParams.get("w");
        if (w!== null){
            parameters.w= w;
        }
        const h = searchParams.get("h");
        if (h!== null){
            parameters.h= h;
        }
        const auto_lightning_enable = searchParams.get("auto_lightning_enable");
        if (auto_lightning_enable !== null ){
            parameters.auto_lightning_enable= auto_lightning_enable;
        }
        const basemapValue = searchParams.get("basemapValue");
		
		//Hide special marines if specified by parameter
        const hideSpecialMarines = searchParams.get("hideSpecialMarines");
		if (hideSpecialMarines !== null ){
            parameters.hideSpecialMarines = true;
        }
		
		//Highlight critical warnings if specified by parameter
        const highlightCriticalWarnings = searchParams.get("highlightCriticalWarnings");
		if (highlightCriticalWarnings !== null ){
            parameters.highlightCriticalWarnings = true;
        }
        
        //Disabling Stadia tiles for Mike's iOS users because they're getting 401 error most likely because non-US traffic is blocked
        if(key == 't3asqi2AuEMYNOe' && (checkIsIOsPhone() || checkIsSafariBrowser())){
            parameters.basemapValue = 'voyager';
        }else if(basemapValue !== null){
			parameters.basemapValue = basemapValue;
        }
        
        
        return parameters
    }
    
    const getDeviceType = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        const isMobile = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);

        setDeviceType(isMobile ? "mobile" : "desktop");
    }
    
    const checkIsIOsPhone = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        return /iphone|ipod|ipad/.test(userAgent);
        
    }
    
    const checkIsSafariBrowser = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        return /^((?!chrome|android|crios|fxios|edgios|opr).)*safari/i.test(userAgent);
        
    }

    useEffect(() => {
        config();
        getDeviceType();
    }, []);

    return (
        <div className={'device-'+deviceType}>
            
                <LoadingContext.Provider value={ setLoading }>
                    { load >=1 && <Loading/> }
                    <ParameterContext.Provider value = { parameters }>
                        { (load == 0 && errorMessage !== "") && <div>
                            <b>Error:</b> {errorMessage}. Please contact <a href="mailto:support@zoomradar.com">support@zoomradar.com</a>!
                        </div>
                        }
                        {parameters && <Map/>}
                    </ParameterContext.Provider>
                </LoadingContext.Provider>


        </div>
    );
};

export default App;
